<template>
  <div class="home">
    <div class="banner">
      <img alt="Vue logo" style="width: 64px; height: 64px" src="../assets/logo.png" />
      <h3 style="margin-top: 1rem">Welcome to Your Vue.js App</h3>
    </div>

    <br />

    <h2># Trend 组件</h2>

    <a-divider> 正常 </a-divider>

    <a-card>
      <trend flag="up" style="margin-right: 16px;">
        <span slot="term">工资</span>
        5%
      </trend>
      <trend flag="up" style="margin-right: 16px;">
        <span slot="term">工作量</span>
        50%
      </trend>
      <trend flag="down">
        <span slot="term">身体状态</span>
        50%
      </trend>
    </a-card>

    <a-divider> 颜色反转 </a-divider>

    <a-card style="margin-bottom: 3rem">
      <trend flag="up" :reverse-color="true" style="margin-right: 16px;">
        <span slot="term">工资</span>
        5%
      </trend>
      <trend flag="down" :reverse-color="true" style="margin-right: 16px;">
        <span slot="term">工作量</span>
        50%
      </trend>
    </a-card>

    <h2># AvatarList 组件</h2>

    <a-divider> AvatarList </a-divider>
    <a-card style="margin-bottom: 3rem">
      <avatar-list :max-length="3">
        <avatar-list-item tips="Jake" src="https://gw.alipayobjects.com/zos/rmsportal/zOsKZmFRdUtvpqCImOVY.png" />
        <avatar-list-item tips="Andy" src="https://gw.alipayobjects.com/zos/rmsportal/sfjbOqnsXXJgNCjCzDBL.png" />
        <avatar-list-item tips="Niko" src="https://gw.alipayobjects.com/zos/rmsportal/kZzEzemZyKLKFsojXItE.png" />
        <avatar-list-item tips="Niko" src="https://gw.alipayobjects.com/zos/rmsportal/kZzEzemZyKLKFsojXItE.png" />
        <avatar-list-item tips="Niko" src="https://gw.alipayobjects.com/zos/rmsportal/kZzEzemZyKLKFsojXItE.png" />
        <avatar-list-item tips="Niko" src="https://gw.alipayobjects.com/zos/rmsportal/kZzEzemZyKLKFsojXItE.png" />
        <avatar-list-item tips="Niko" src="https://gw.alipayobjects.com/zos/rmsportal/kZzEzemZyKLKFsojXItE.png" />
      </avatar-list>

      <a-divider type="vertical" style="margin: 0 16px" />

      <avatar-list size="mini">
        <avatar-list-item tips="Jake" src="https://gw.alipayobjects.com/zos/rmsportal/zOsKZmFRdUtvpqCImOVY.png" />
        <avatar-list-item tips="Andy" src="https://gw.alipayobjects.com/zos/rmsportal/sfjbOqnsXXJgNCjCzDBL.png" />
        <avatar-list-item tips="Niko" src="https://gw.alipayobjects.com/zos/rmsportal/kZzEzemZyKLKFsojXItE.png" />
      </avatar-list>
    </a-card>

    <h2># CountDown 组件</h2>

    <a-divider> CountDown </a-divider>
    <a-card style="margin-bottom: 3rem">
      <count-down style="font-size: 2rem" :target="new Date().getTime() + 3000000" :on-end="onEndHandle"> </count-down>

      <a-divider type="vertical" style="margin: 0 16px" />

      <count-down style="font-size: 2rem" :target="new Date().getTime() + 10000" :on-end="onEndHandle2"> </count-down>
    </a-card>

    <h2># Ellipsis 组件</h2>

    <a-divider> Ellipsis </a-divider>
    <a-card style="margin-bottom: 3rem">
      <ellipsis :length="100" tooltip>
        There were injuries alleged in three cases in 2015, and a fourth incident in September, according to the safety
        recall report. After meeting with US regulators in October, the firm decided to issue a voluntary recall.
      </ellipsis>
    </a-card>

    <h2># NumberInfo 组件</h2>

    <a-divider> NumberInfo </a-divider>
    <a-card style="margin-bottom: 3rem">
      <number-info
        :sub-title="
          () => {
            return 'Visits this week'
          }
        "
        :total="12321"
        status="up"
        :sub-total="17.1"
      ></number-info>
    </a-card>

    <h2># TagSelect 组件</h2>

    <a-divider> TagSelect </a-divider>
    <a-card style="margin-bottom: 3rem">
      <tag-select>
        <tag-select-option value="cat1">类目1</tag-select-option>
        <tag-select-option value="cat2">类目2</tag-select-option>
        <tag-select-option value="cat3">类目3</tag-select-option>
        <tag-select-option value="cat4">类目4</tag-select-option>
        <tag-select-option value="cat5">类目5</tag-select-option>
        <tag-select-option value="cat6">类目6</tag-select-option>
        <tag-select-option value="cat7">类目7</tag-select-option>
      </tag-select>
    </a-card>

    <h2># DescriptionList 组件</h2>

    <a-divider> DescriptionList </a-divider>
    <a-card style="margin-bottom: 3rem">
      <description-list title="组名称" size="small">
        <description-list-item term="负责人">林东东</description-list-item>
        <description-list-item term="角色码">1234567</description-list-item>
        <description-list-item term="所属部门">XX公司-YY部</description-list-item>
        <description-list-item term="过期时间">2018-08-08</description-list-item>
        <description-list-item term="描述">这段描述很长很长很长很长很长很长很长很长很长很长很长很长很长很长...</description-list-item
        >
      </description-list>
    </a-card>

    <a-divider> TagCloud </a-divider>
    <a-card style="margin-bottom: 3rem">
      <tag-cloud :tag-list="tagCloudData"></tag-cloud>
    </a-card>

    <h2># ArticleListContent 文章列表组件</h2>
    <a-divider> ArticleListContent </a-divider>
    <a-card style="margin-bottom: 3rem">
      <article-list-content
        updateAt="2022-01-01 08:00:00"
        owner="zs"
        avatar="https://gw.alipayobjects.com/zos/rmsportal/zOsKZmFRdUtvpqCImOVY.png"
        href="www.baidu.com"
      />
    </a-card>

    <h2># Drawer 组件</h2>
    <a-divider> Drawer </a-divider>
    <a-card style="margin-bottom: 3rem">
      <a-button @click="visible = true">Drawer</a-button>
      <drawer title="title" :visible="visible" @handleOk="visible = false" @handleCancel="visible = false"></drawer>
    </a-card>

    <h2># QuillEditor 组件</h2>
    <a-divider> QuillEditor </a-divider>
    <a-card style="margin-bottom: 3rem">
      <quill-editor></quill-editor>
    </a-card>

    <h2># Editor135 组件</h2>
    <a-divider> Editor135 </a-divider>
    <a-card style="margin-bottom: 3rem">
      <editor135></editor135>
    </a-card>

    <h2># ExceptionPage 组件</h2>
    <a-divider> ExceptionPage </a-divider>
    <a-card style="margin-bottom: 3rem">
      <exception-page></exception-page>
    </a-card>

    <h2># GlobalFooter 组件</h2>
    <a-divider> GlobalFooter </a-divider>
    <a-card style="margin-bottom: 3rem">
      <global-footer></global-footer>
    </a-card>

    <h2># GlobalHeader 组件</h2>
    <a-divider> GlobalHeader 效果暂时不明 </a-divider>
    <a-card style="margin-bottom: 3rem">
      <global-header :menus="['zs', 'ls']"></global-header>
    </a-card>

    <h2># icon 组件</h2>
    <a-divider> icon </a-divider>
    <a-card style="margin-bottom: 3rem">
      <icon-selector></icon-selector>
    </a-card>

    <h2># QueryForm 组件</h2>
    <a-divider> QueryForm </a-divider>
    <a-card style="margin-bottom: 3rem">
      <query-form></query-form>
    </a-card>

    <h2># SMenu 组件</h2>
    <a-divider> SMenu 使用不明</a-divider>
    <a-card style="margin-bottom: 3rem">
      <!-- <s-menu :menu="['zs','ls']"></s-menu> -->
    </a-card>

    <h2># MultiTab 组件</h2>
    <a-divider> MultiTab 使用不明</a-divider>
    <a-card style="margin-bottom: 3rem">
      <!-- <multi-tab></multi-tab> -->
    </a-card>

    <h2># TitleTab 组件</h2>
    <a-divider> TitleTab 使用不明</a-divider>
    <a-card style="margin-bottom: 3rem">
      <!-- <TitleTab></TitleTab> -->
    </a-card>

    <h2># NoticeIcon 组件</h2>
    <a-divider> NoticeIcon </a-divider>
    <a-card style="margin-bottom: 3rem">
      <notice-icon></notice-icon>
    </a-card>
    <h2># PageHeader 组件</h2>
    <a-divider> PageHeader 不知道作用 </a-divider>
    <a-card style="margin-bottom: 3rem">
      <PageHeader
        title="title"
        avatar="https://gw.alipayobjects.com/zos/rmsportal/zOsKZmFRdUtvpqCImOVY.png"
        logo="https://gw.alipayobjects.com/zos/rmsportal/zOsKZmFRdUtvpqCImOVY.png"
      >
        <template slot="content">
          <div>
            content
          </div>
        </template>
        <template slot="action">
          <div>
            action
          </div>
        </template>
        <template slot="extra">
          <div>
            extra
          </div>
        </template>
        <template slot="pageMenu">
          <div>
            pageMenu
          </div>
        </template>
      </PageHeader>
    </a-card>

    <h2># Modal 组件</h2>
    <a-divider> 格式较为固定的Modal组件 </a-divider>
    <!-- <GoodsModal></GoodsModal> -->
    <!-- <GoodsListModle></GoodsListModle> -->
    <!-- <ClassesListModle></ClassesListModle> -->
    <!-- <CommodityListModle></CommodityListModle> -->
    <!-- <vipListModle></vipListModle> -->
    <!-- <SuitListModle></SuitListModle> -->
    <h2># progressBar 组件</h2>
    <a-divider> progressBar </a-divider>
    <a-card style="margin-bottom: 3rem">
      <progressBar></progressBar>
    </a-card>
    <h2># result 组件</h2>
    <a-divider> result </a-divider>
    <a-card style="margin-bottom: 3rem">
      <result title="title" description="description"></result>
    </a-card>
    <h2># SettingDrawer 组件</h2>
    <a-divider> SettingDrawer 主题设置 </a-divider>
    <a-card style="margin-bottom: 3rem">
      <SettingDrawer></SettingDrawer>
    </a-card>
    <h2># SitesEditorSpin 组件</h2>
    <a-divider> SitesEditorSpin </a-divider>
    <a-card style="margin-bottom: 3rem">
      <SitesEditorSpin :loading="true"></SitesEditorSpin>
    </a-card>
    <h2># StandardFormRow 组件</h2>
    <a-divider> StandardFormRow </a-divider>
    <a-card style="margin-bottom: 3rem">
      <StandardFormRow title="title">
        <a-button>button</a-button>
      </StandardFormRow>
    </a-card>
    <h2># TextArea 组件</h2>
    <a-divider> TextArea </a-divider>
    <a-card style="margin-bottom: 3rem">
      <TextArea></TextArea>
    </a-card>
    <!-- <TheFormRadioSelect></TheFormRadioSelect> -->
    <!-- <TheFormAside></TheFormAside> -->
    <h2># FooterToolBar 组件</h2>
    <a-divider> FooterToolBar </a-divider>
    <a-card style="margin-bottom: 3rem">
      <footer-tool-bar>
        <a-button type="primary">右边</a-button>
        <template>
          <div slot="extra">
            <a-button type="primary">左边</a-button>
          </div>
        </template>
      </footer-tool-bar>
    </a-card>
    <h2># 图片预览 组件</h2>
    <a-divider> v-viewer </a-divider>
    <div class="images" v-viewer>
      <img v-for="src in images" :key="src" :src="src">
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Vue from 'vue'
import Trend from '@/components/Trend'
import AvatarList from '@/components/AvatarList'
import CountDown from '@/components/CountDown/CountDown'
import Ellipsis from '@/components/Ellipsis'
import NumberInfo from '@/components/NumberInfo'
import TagSelect from '@/components/TagSelect'
import {
  DescriptionList,
  TagCloud,
  QuillEditor,
  Editor135,
  ExceptionPage,
  FooterToolBar,
  IconSelector,
  MultiTab,
  TitleTab,
  GoodsModal,
  GoodsListModle,
  ClassesListModle,
  CommodityListModle,
  vipListModle,
  SuitListModle,
  Result,
  StandardFormRow,
  TheFormRadioSelect,
  TheFormAside
} from '@/components/'
import ArticleListContent from '@/components/ArticleListContent'
import Drawer from '@/components/Drawer/Index.vue'
import GlobalFooter from '@/components/GlobalFooter'
import GlobalHeader from '@/components/GlobalHeader'
import QueryForm from '@/components/materiel/QueryForm.vue'
import SMenu from '@/components/Menu/index'
import NoticeIcon from '@/components/NoticeIcon'
import PageHeader from '@/components/PageHeader'
import progressBar from '@/components/progressBar/progressBar'
import SettingDrawer from '@/components/SettingDrawer'
import SitesEditorSpin from '@/components/SitesEditorSpin/SitesEditorSpin.vue'
import TextArea from '@/components/TextArea/index'
  import 'viewerjs/dist/viewer.css'
  import VueViewer from 'v-viewer'
const AvatarListItem = AvatarList.AvatarItem
const TagSelectOption = TagSelect.Option

const DescriptionListItem = DescriptionList.Item
Vue.use(VueViewer)
export default {
  name: 'Home',
  components: {
    NumberInfo,
    Ellipsis,
    CountDown,
    Trend,
    AvatarList,
    AvatarListItem,
    TagSelect,
    TagSelectOption,
    TagCloud,
    DescriptionList,
    DescriptionListItem,
    ArticleListContent,
    Drawer,
    QuillEditor,
    Editor135,
    ExceptionPage,
    FooterToolBar,
    GlobalFooter,
    GlobalHeader,
    IconSelector,
    QueryForm,
    SMenu,
    MultiTab,
    TitleTab,
    NoticeIcon,
    PageHeader,
    GoodsModal,
    GoodsListModle,
    ClassesListModle,
    CommodityListModle,
    vipListModle,
    SuitListModle,
    progressBar,
    Result,
    SettingDrawer,
    SitesEditorSpin,
    StandardFormRow,
    TextArea,
    TheFormRadioSelect,
    TheFormAside,
    VueViewer
  },
  data() {
    return {
      targetTime: new Date().getTime() + 3900000,
      tagCloudData: [],
      visible: false,
      loading: false,
      images: [
          'https://picsum.photos/200/200',
          'https://picsum.photos/300/200',
          'https://picsum.photos/250/200'
        ]
    }
  },
  created() {
    // this.getTagCloudData()
  },
  methods: {
    onEndHandle() {
      this.$message.success('CountDown callback!!!')
    },
    onEndHandle2() {
      this.$notification.open({
        message: 'Notification Title',
        description:
          'This is the content of the notification. This is the content of the notification. This is the content of the notification.'
      })
    },
    getTagCloudData() {
      this.$http.get('/data/antv/tag-cloud').then(res => {
        this.tagCloudData = res.result
      })
    }
  }
}
</script>

<style scoped>
.home {
  width: 900px;
  margin: 0 auto;
  padding: 25px 0;
}
.home > .banner {
  text-align: center;
  padding: 25px 0;
  margin: 25px 0;
}
</style>
